import { classInstance, enableScroll, disableScroll } from '@/shared/helpers/helpers';

export class LibrarySearch {
	constructor(selector, options = {}) {
		this.$container = selector;

		if (!this.$container) return;

		this.selectorFilter = options.selectorFilter || '.js-library-search__filter';
		this.selectorOpen = options.selectorOpen || '.js-library-search__open';
		this.selectorClose = options.selectorClose || '.js-library-search__close';

		this.init();
	}

	init() {
		classInstance.set(this.$container, { librarySearch: this });

		this.$filter = this.$container.querySelector(this.selectorFilter);
		this.$openArr = this.$container.querySelectorAll(this.selectorOpen);
		this.$closeArr = this.$container.querySelectorAll(this.selectorClose);

		this.$openArr.forEach((element) =>
			element.addEventListener('click', this.openHandler.bind(this)),
		);
		this.$closeArr.forEach((element) =>
			element.addEventListener('click', this.closeHandler.bind(this)),
		);
	}

	destroy() {
		classInstance.del(this.$container, 'librarySearch');
		this.$openArr.forEach((element) =>
			element.removeEventListener('click', this.openHandler.bind(this)),
		);
		this.$closeArr.forEach((element) =>
			element.removeEventListener('click', this.closeHandler.bind(this)),
		);
	}

	reinit() {
		this.destroy();
		this.init();
	}

	openHandler() {
		this.toggleFilter(true);
	}

	closeHandler() {
		this.toggleFilter(false);
	}

	toggleFilter(key) {
		this.$filter.classList.toggle('active', key);
		if (key) {
			disableScroll();
		} else {
			enableScroll();
		}
	}
}
